import { Component, ElementRef, forwardRef, HostListener, Input, OnChanges, OnInit, SimpleChanges, ViewChildren } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export class FilterDropdown {
  id: number;
  name: string;
  rawValue?: any;

  constructor(id: number, name: string, rawValue?: any) {
    this.id = id;
    this.name = name;
    this.rawValue = rawValue;
  }
}
@Component({
  selector: 'act-filter-dropdown',
  templateUrl: './filter-dropdown.component.html',
  styleUrls: ['./filter-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilterDropdownComponent),
      multi: true
    }
  ]
})
export class FilterDropdownComponent implements OnInit, OnChanges, ControlValueAccessor {
  onChange: Function;
  onTouch: Function;
  isShow = false;
  isDropUp = false;
  search = '';
  listShow: FilterDropdown[] = [];
  disabled = false;

  @ViewChildren('list') list;

  @Input() defaultSelect: string;
  @Input() listInput: FilterDropdown[];
  @Input() name: string;
  @Input() value: string;
  @Input() error: boolean;
  @Input() defaultName = '';
  @Input() isSetDefaultSelect = false;

  constructor(
    private elRef: ElementRef
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.listShow = this.listInput;
    if ((!changes.error || (changes.error !== undefined && changes.error.currentValue)) && this.isSetDefaultSelect) {
      this.defaultSelect = this.defaultName;
    }
    this.name = this.name === undefined ? '' : this.name;
  }

  ngOnInit() {
  }

  writeValue(value: any) {
    this.value = value
    if (this.value && this.listInput) {
      try {
        this.defaultSelect = this.listInput.find(x => x.id === value.id).name;
      } catch (e) {
        this.defaultSelect = this.defaultName;
      }
    }
  }

  registerOnChange(onChange: Function) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouch: Function) {
    this.onTouch = onTouch;
  }

  onClickDDL() {
    this.listShow = this.listInput;

    const isMobile = window.innerWidth <= 425;
    const menuHeight = isMobile ? (40 * 6) : (40 * 11);

    const windowHeight = window.innerHeight;
    const boundClientRect = this.elRef.nativeElement.getBoundingClientRect();
    const buttonPosition = boundClientRect.top;
    const buttonHeight = boundClientRect.height;

    this.isDropUp = windowHeight - buttonPosition < buttonHeight + menuHeight;

    this.isShow = !this.isShow;
  }

  filterFunction() {
    const filter = this.search.trim().toUpperCase();
    this.listShow = this.listInput.filter(x => x.name.toUpperCase().includes(filter));
  }

  onSelect(value: any) {
    this.defaultSelect = value.name;
    this.isShow = false;
    this.search = '';
    this.filterFunction();
    this.onChange(value);
  }

  @HostListener('document:click', ['$event'])
  public onClick(event) {
    if (!this.elRef.nativeElement.contains(event.target) && !this.disabled) {
      this.isShow = false;
      this.search = '';
    }
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/filter-dropdown/filter-dropdown.component.ts